import React, { useEffect, useState, useContext } from 'react';
import { CartContext } from 'utils/cart';
import { writeStorage } from '@rehooks/local-storage';

export function tryParse( value ) {
    try {
        return JSON.parse( value );
    } catch ( _a ) {
        return value;
    }
}

const getCartFromContext = () => useContext( CartContext );

const getAmountFromCart = (cart) => cart.map( x => x.amount ).reduce( ( a, b ) => a + b, 0);

export default ( id ) => {
    const [ cart ] = getCartFromContext();

    const [ item, setItem ] = useState( null );

    useEffect( () => {
        let cartCopy = tryParse( cart );

        //assuming we have an ID field in our item
        //look for item in cart array
        let existingItem = cartCopy.find( cartItem => cartItem.id === id );
        setItem( existingItem );

    }, [ cart ] );

    const updateItem = (amount = 1) => {
        //create a copy of our cart state, avoid overwritting existing state
        const cartStr = window.localStorage.getItem( 'oc' );
        let cartCopy = cartStr ? [ ...JSON.parse( cartStr ) ] : []

        //assuming we have an ID field in our item
        //look for item in cart array
        let existingItem = cartCopy.find( cartItem => cartItem.id === id );

        //if item already exists
        if ( existingItem ) {
            //existingItem.amount += amount //update item
            if ( existingItem.amount + amount <= 0 ) {
                cartCopy = cartCopy.filter( item => item.id !== id )
            } else {
                existingItem.amount += amount;
            }
        } else if ( amount > 0 ) { //if item doesn't exist, simply add it
            cartCopy.push( { id, amount } )
        }

        //update app state
        writeStorage( 'oc', cartCopy );
    };

    const removeItem = () => {
        const cartStr = window.localStorage.getItem( 'oc' );
        let cartCopy = cartStr ? [ ...JSON.parse( cartStr ) ] : []

        let existingItem = cartCopy.find( cartItem => cartItem.id === id );
        if ( !existingItem ) {
            return
        } else { //if item doesn't exist, simply add it
            cartCopy = cartCopy.filter( item => item.id !== id )
        }
        //setCart( cartCopy )
        writeStorage( 'oc', cartCopy);

    }

    if ( !id ) {
        return { cart };
    }

    return {
        item,
        updateItem,
        removeItem
    };
}
